export enum OpticalMetricMark {
  Poor = 'P',
  Fair = 'F',
  Good = 'G',
  VeryGood = 'VG',
  Excellent = 'EX',
  Outstanding = 'OU',
}

export const P = OpticalMetricMark.Poor;
export const F = OpticalMetricMark.Fair;
export const G = OpticalMetricMark.Good;
export const VG = OpticalMetricMark.VeryGood;
export const EX = OpticalMetricMark.Excellent;
export const OU = OpticalMetricMark.Outstanding;

export const OPTICAL_METRIC_MARKS = [P, F, G, VG, EX, OU];
